import { i18n } from '@lingui/core'
import { SwipeableDrawer } from '@mui/material'
import Link from 'next/link'
import { useContext, useEffect, useState } from 'react'
import useDetectDevice, { DetectDeviceProps } from '../../hooks/useDetectDevice'
import useWindowSize from '../../hooks/useWindowSize'
import { AiChatFab } from '../AI/AiChatFab'
import { CustomerFab } from '../Customer/CustomerFab/CustomerFab'
import { OrdersFab } from '../Customer/OrdersFab/OrdersFab'
// eslint-disable-next-line import/no-cycle
// eslint-disable-next-line import/no-cycle
import { HeaderTabs } from '../Header/HeaderTabs'
import { MegaMenuHeader } from '../Header/MegaMenuHeader'
import { NavigationDesktop } from '../Header/NavigationDesktop'
import { NavigationMobile } from '../Header/NavigationMobile'
import { NewMegaMenuHeaderTabs } from '../Header/NewMegaMenuHeaderTabs'
import { Promo } from '../Header/Promo'
import { CartFab } from '../Minicart/CartFab'
import { globalContext } from '../NextUi/globalContext'
import { SearchForm } from '../Search/SearchForm'
import { HeaderQueryFragment } from './HeaderQueryFragment.gql'
import { Icon } from './Icon'
import { LayoutQuery } from './Layout.gql'
import { Logo } from './Logo'

export type HeaderProps = Pick<LayoutQuery, 'menu'> & HeaderQueryFragment

export function Header(props: HeaderProps) {
  const { menu, header } = props
  const { isMobile } = useWindowSize()
  const { drawer, setDrawer } = useContext(globalContext)
  const deviceDetails: DetectDeviceProps = useDetectDevice() || {}
  const isTablet = deviceDetails?.isTablet || deviceDetails?.isIPad
  const [value, setValue] = useState<string>('')

  useEffect(() => {
    if (drawer?.id === 'nav') {
      setValue('*')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawer])

  const aiChatFab = <AiChatFab className='flex h-[42px] items-center justify-center' />

  return (
    <header className='sticky top-0 z-50 block w-full border-b-[1px] border-b-20-grey bg-pure-white'>
      {!isMobile && header?.promoText ? (
        <Promo text={header?.promoText} />
      ) : (
        isMobile && (
          <div className='grid h-[55px] grid-cols-3 items-center bg-none px-3'>
            {aiChatFab}
            <Link href='/' className='flex items-center justify-center'>
              <Logo mode='purple' />
            </Link>
            <div className='flex items-center justify-end gap-3'>
              <CustomerFab />
              <CartFab />
            </div>
          </div>
        )
      )}
      <div className='flex w-full flex-col items-center justify-center md:px-[5%]'>
        <div
          className={`mx-auto flex h-[60px] w-full max-w-maxContentWidth items-center justify-between px-5 py-3 sm:h-auto sm:border-none ${
            isTablet ? 'md:ml-[36px] lg:ml-[36px]' : 'md:mx-0'
          } md:justify-between 2xl:px-0`}
        >
          {!isMobile && (
            <div className='flex items-center justify-between gap-6'>
              <Link href='/'>
                <div className='h-full pt-1'>
                  <Logo />
                </div>
              </Link>
              {/* {!isTablet && <HeaderTabs menu={menu} />} */}
            </div>
          )}
          <div className='flex w-full items-center justify-between py-2 md:py-0'>
            <SearchForm aria-label={i18n._(/* i18n */ 'Search...')} />
            <div className='hidden items-center justify-end gap-4 md:flex'>
              {aiChatFab}
              <OrdersFab />
              <CustomerFab />
              <CartFab />
              {isTablet && (
                <button
                  type='button'
                  className='ml-[24px] inline-flex h-full items-center border-l-[0.5px] border-l-20-grey py-4 pl-[10px]'
                  onClick={() => setDrawer({ id: drawer.id === 'nav' ? null : 'nav' })}
                >
                  <Icon name='menu' className='cursor-pointer  text-2xl text-70-grey' />
                </button>
              )}
            </div>
            {isMobile && !isTablet && (
              <button
                type='button'
                className='ml-5 inline-flex h-full items-center'
                onClick={() => setDrawer({ id: drawer.id === 'nav' ? null : 'nav' })}
              >
                <Icon name='menu' className='cursor-pointer  text-2xl text-70-grey' />
              </button>
            )}
          </div>
        </div>
        {!isMobile && <MegaMenuHeader menu={menu} value={value} setValue={setValue} />}
      </div>
      {(isMobile || isTablet) && (
        <SwipeableDrawer
          anchor='right'
          onClose={() => setDrawer({ id: null })}
          onOpen={() => {}}
          open={drawer.id === 'nav'}
          classes={{
            paper: 'rounded-l-[10px] min-h-[69px] w-full',
          }}
        >
          <NewMegaMenuHeaderTabs
            menu={menu}
            closeModal={() => setDrawer({ id: null })}
            value={value}
            setValue={setValue}
          />
        </SwipeableDrawer>
      )}
    </header>
  )
}
